import React from "react";
import ClinicSidebar from "../components/sidebar/ClinicSidebar";
import ClinicHeader from "../components/header/ClinicHeader";

const ClinicLayout = ({ children, noSidebar }) => {
  return (
    <div className="flex flex-col h-screen bg-[#F4FAF1]">
      {!noSidebar && <ClinicHeader />}
      <div className="flex flex-1 h-screen overflow-hidden">
        {!noSidebar && <ClinicSidebar />}
        <main className={"flex-1 overflow-y-auto" + `${noSidebar ? "" : " p-4 sm:ml-1"}`}>{children}</main>
      </div>
    </div >
  );
};

export default ClinicLayout;
